import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromNews from '../reducers/news.reducer';
import { News } from '../../models';
import * as fromRoot from '../../../store';

export const getNewsState = createSelector(fromFeature.getContentState, (state: fromFeature.ContentState) => state.news);

export const getNewsEntities = createSelector(getNewsState, fromNews.getNewsEntities);
export const getNewsLoaded = createSelector(getNewsState, fromNews.getNewsLoaded);
export const getNewsLoading = createSelector(getNewsState, fromNews.getNewsLoading);

export const getNewsOverviewEntities = createSelector(getNewsState, fromNews.getNewsOverviewEntities);
export const getNewsOverviewLoaded = createSelector(getNewsState, fromNews.getNewsOverviewLoaded);
export const getNewsOverviewLoading = createSelector(getNewsState, fromNews.getNewsOverviewLoading);

export const getAllNews = createSelector(getNewsEntities, entities => {
  return Object.keys(entities).map(id => entities[+id]);
});

export const getOrderedNews = createSelector(getAllNews, (Pages: News[]) => {
  const orderedPages = Pages.sort((a, b) => (new Date(b.publishDate) > new Date(a.publishDate) ? 1 : -1));
  return orderedPages;
});

export const getSelectedNews = createSelector(getNewsOverviewEntities, fromRoot.getRouterState, (entities, router): News => {
  return router.state && entities[router.state.params?.['pageId'] || router.state.data?.['pageId']];
});
